import { SoilTestObservations } from '@/models/SoilTest'

import { get } from '../axios/serverConfig'

const fetchSoilTestObservations = (accessToken: string) =>
  get<SoilTestObservations[]>('/soil/v3/observations', {}, accessToken)

export default fetchSoilTestObservations
